<template>
  <div class="bg">
    <p class="d-flex justify-center">Copyright © 2022 - 2026 | LéoLearning</p>
  </div>
</template>

<script>
export default {
  name: "FooterApp",
};
</script>

<style>
.bg {
  background-color: #d6d6d6;
}
</style>
